import React from 'react';

import {HStack, Text, VStack, Image} from "@chakra-ui/react";

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components";
import stringUtil from "@/utils/stringUtil";

export const PartnerBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(50, 80) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const PartnerBody = ({element, ...props}) => {
    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            color={element.deleted ? "gray.400" : "secondary.500"}
            overflow="hidden"
            {...props}
        >
            {element.logo && (
                <Image
                    src={element.logo}
                    alt={element.title}
                    boxSize="40px"
                    objectFit="contain"
                    borderRadius="md"
                />
            )}
            <VStack align="flex-start" flex={1} overflow="hidden">
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                    color={element.deleted ? "gray.400" : "inherit"}
                >
                    {element.title}
                </Text>
                {element.url && (
                <Text
                    fontSize="sm"
                    color="secondary.500"
                    isTruncated
                >
                        {element.url}
                    </Text>
                )}
            </VStack>
        </HStack>
    );
};

export default PartnerBody;
